export const LanguageRouteParameterPart = ':language';

export enum Language {
    English = 'en',
    Bulgarian = 'bg'
}

export const Languages: string[] = [
    Language.English,
    Language.Bulgarian
];
